import { useState } from "react";
import { Routes, Route } from "react-router-dom";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import IconLinkedin from "./icon/Linkedin";
import IconGithub from "./icon/Github";
import Logo from "./icon/Logo";

function Header() {
  const location = useLocation().pathname;
  const newPath = location.toString();
  const [path, setPath] = useState(newPath);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {isOpen && (
        <div className="fixed top-0 left-0 right-0 bottom-0 bg-black/80 z-[900] flex">
          <div className="w-[50%] bg-white m-auto rounded-md">
            <h3 className="text-[#d30909] font-bold text-4xl text-center p-5">
              Cảnh báo
            </h3>
            <p className="p-5 text-center text-lg">
              Bạn đang truy cập vào trang web{" "}
              <strong>không đáng tin cậy</strong>.
            </p>
            <p className="px-5 text-center text-lg">
              Bạn có muốn tiếp tục truy cập không?
            </p>

            <p className="px-24 pt-3 text-base font-bold">Password</p>
            <div className="p-4 pt-1 pb-2 px-24">
              <input type="text" className="text-base border w-full p-3" />
            </div>

            <div className="p-9 flex gap-3 justify-end cursor-pointer">
              <div
                className="px-3 py-2 border border-[#039200] rounded text-[#039200]"
                onClick={() => setIsOpen(false)}
              >
                Không truy cập
              </div>
              <div
                className="px-3 py-2 bg-red-400 rounded text-white"
                onClick={() => setIsOpen(false)}
              >
                Tiếp tục truy cập
              </div>
            </div>
          </div>
        </div>
      )}
      <div>
        <ul className=" w-full pl-20 flex justify-around items-center pr-20">
          <li className="py-[17px] flex-1 ">
            <Link
              to="/"
              className="cursor-pointer"
              onClick={() => {
                setPath("/");
              }}
            >
              <Logo />
            </Link>
          </li>

          <li className=" flex-4  flex justify-around items-center gap-5 ">
            <div className="min-w-[130px] font-bold text-[#06bf10] animate-bounce">
              <Link to="/" onClick={() => setIsOpen(true)}>
                Download ngay!
              </Link>
            </div>

            <div className="">
              <Link
                to="/"
                className={"heading" + (path == "/" ? " heading_hover" : "")}
                onClick={() => setPath("/")}
              >
                Trang Chủ
              </Link>
            </div>

            <div className="">
              <Link
                to="/about"
                className={
                  "heading" + (path == "/about" ? " heading_hover" : "")
                }
                onClick={() => setPath("/about")}
              >
                About
              </Link>
            </div>

            <div className="">
              <Link
                to="/test"
                className={
                  "heading" + (path == "/test" ? " heading_hover" : "")
                }
                onClick={() => setPath("/test")}
              >
                Thi Thử
              </Link>
            </div>

            <div className="">
              <Link
                to="/document"
                className={
                  "heading" + (path == "/document" ? " heading_hover" : "")
                }
                onClick={() => setPath("/document")}
              >
                Tài Liệu
              </Link>
            </div>

            <div className="">
              <Link
                to="/admin"
                className={
                  "heading" + (path == "/admin" ? " heading_hover" : "")
                }
                onClick={() => setPath("/admin")}
              >
                Admin
              </Link>
            </div>

            <div className="flex ">
              <a
                className="cursor-pointer ml-[2em]"
                href="https://www.linkedin.com/"
                target="_blank"
                rel="noreferrer"
              >
                <IconLinkedin />
              </a>
              <a
                className="cursor-pointer  ml-[2em] "
                href="https://github.com/FunDev-Team"
                target="_blank"
                rel="noreferrer"
              >
                <IconGithub />
              </a>
            </div>
          </li>
        </ul>
      </div>
    </>
  );
}

export default Header;
